import React, { useState, useEffect, useCallback } from 'react'
import { bindActionCreators } from "redux";
import { returnType } from "../Utilities/ReturnType";
import { connect } from "react-redux";
import { GlobalAutoHealing } from "../Interface/IGlobalAutoHealing";
import { useSearchParams, useLocation } from 'react-router-dom'
import { Spinner, SpinnerSize } from 'office-ui-fabric-react'
import { getContentMarkerReview, getMakeasReviewed, getArchiveArticle, getImproveArticle, getCorrectOwner, getCorrectOwnerData } from "../../redux/Actions/PowerDataQuery";
import { RemediationUsers } from '../../ConfigData/RemediationUsers'
import { useNavigate } from "react-router-dom";
import { IHealingCompleteParams } from "../Interface/Params/IAutoHealingPayload"
import {  useMsal, useAccount } from "@azure/msal-react";
import CustomMessageAlert from "../CustomMessageAlert/CustomMessageAlert";
import { TextField } from '@fluentui/react';
import { Dropdown, IDropdownStyles, IDropdownOption } from '@fluentui/react/lib/Dropdown';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType, PrimaryButton, DefaultButton } from '@fluentui/react';
import { Stack, ChoiceGroup, IChoiceGroupOption } from '@fluentui/react';
import SingleIdentityPickerExtension from '../Controls/BreadCrumbExtension/IdentityPicker/SingleIdentityPickerExtension'

import './TicketAssignedTo.css'

const actionCreators = {
    getContentMarkerReview,
    getArchiveArticle, 
    getImproveArticle,
    getMakeasReviewed
};

type DispatchProps = typeof actionCreators;

const mapStateToProps = (state: GlobalAutoHealing) => ({
    apiResponseState: state.apiResponseState,
    reviewContentMarker: state.reviewContentMarker,
    replaceContent: state.replaceContent,
    radioSelected: state.radioSelected,
});

const storeProps = returnType(mapStateToProps);
type StoreProps = typeof storeProps.returnType;

interface IMessageState {
    showMessage: boolean,
    messageType: string,
    message: string,
    onDismiss?: () => void
}

interface TitcketClose {
    RequiredReviewers?: string,
    Manager?: string,
    onDismiss?: () => void
    onLoadTicketInfo?: (tickerInfo) => void
}

const dropdownStyles: Partial<IDropdownStyles> = { dropdown: { width: 500 } };

const cardStyles = (selected) => ({
    root: {
        width: '100%',
        padding: 16,
        borderRadius: 8,
        border: selected ? '2px solid #0078d4' : '1px solid #ddd',
        background: selected ? '#f3f9fd' : '#fff',
        transition: 'all 0.3s ease',
        boxShadow: selected ? '0 4px 12px rgba(0,0,0,0.1)' : '0 2px 8px rgba(0,0,0,0.05)',
        cursor: 'pointer',
        selectors: {
            ':hover': {
                boxShadow: '0 6px 16px rgba(0,0,0,0.15)',
                transform: 'translateY(-2px)',
            },
        },
    },
});

/**
 * broken link checker
 * @param props 
 * @returns 
 */
function TicketAssignedTo(props: StoreProps & DispatchProps & TitcketClose ) {
    const { accounts } = useMsal();
    const [search] = useSearchParams();
    const requesturl = search.get('url')
    const ticketID = search.get('ticketID')
    const curationID = search.get('curationID')
    const datamart = search.get('datamart')
    const pathArr = useLocation().pathname.split('/')
    const userAccount = useAccount(accounts[0]);

    const history = useNavigate();

    // set the healing complete params
    let healingCompleteParams: IHealingCompleteParams = {
        reviewType: "",
        requesturl: requesturl,
        fixerPath: pathArr[pathArr.length-1],
        traceID: ticketID,
        curationID: curationID,
        completeTitle: "Thank you!"
    }
    
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [showError, { toggle: toggleShowError }] = useBoolean(false);
    const [user, setUser] = useState<string>("");
    const [options, setOptions] = useState<any>([])
    const [selectedItem, setSelectedItem] = React.useState<IDropdownOption>();
    const [userHide, setUserHide] = useState<boolean>(true)
    const [selectedRadioButton, setSelectedRadioButton] = useState<string>("ticket");
    const [multilineObservable, setMultilineObservable] = useState<string>("");

    // const multilineObservable = new ObservableValue<string>("");
    
    const radioOptions: IChoiceGroupOption[] = [
        { key: 'ticket', text: 'Incorrectly assigned to me but I know the correct owner' },
        { key: 'justification', text: "It's been 24hrs since the task was closed/resolved/triaged but it is still flagged in Sonic and Chiron" }
    ];

    const identityPickerChange = useCallback((data: string)=>{
        setUser(data)
    },[])

    const onChange = (event: React.FormEvent<HTMLDivElement>, item: IDropdownOption): void => {
      setSelectedItem(item);
    };

    const [messageState, setMessageState] = useState<IMessageState>(() => {
        return {
            showMessage: false,
            messageType: '',
            message: '',
            onDismiss: null
        }
    })

    const dismissAlert = () => {
        setMessageState({
            messageType: '',
            showMessage: false,
            message: ''
        })
    }

    /**
     * Get the content from the api
     */
    useEffect(() => {
        setUserHide(true);

        // when the url is empty, show the error dialog
        if (!requesturl) {
            window.location.href = `https://aka.ms/ChironDocs`
            return
        }

        getCorrectOwnerData(ticketID).then(res => {
            if (res.Success) {
                var options = [];
                var ops = 0;
                res.Result.Justifacation.map(x => {
                    options.push({ 
                        key: x.Key, 
                        text: x.Value 
                    })

                    if (ops == 0) {
                        ops += 1;
                        setSelectedItem({
                            key: x.Key,
                            text: x.Value
                        });
                    }
                    if (res.Result.JustifacationValue == x.Key) {
                        setSelectedItem({
                            key: x.Key,
                            text: x.Value
                        });
                    }
                })
                setOptions(options);

                // multilineObservable.value = res.Result.Feedback;
                setMultilineObservable(res.Result.Feedback)

                if (res.Result.AssignTo != null && res.Result.AssignTo != "") {
                    setUser(res.Result.AssignTo);
                } else {
                    identityPickerChange(undefined);
                    
                    if (res.Result.JustifacationValue != null && res.Result.JustifacationValue != "") {
                        setSelectedRadioButton("justification")
                    }
                }
                setUserHide(false);
            }else{
                setMessageState({
                    messageType: 'error',
                    showMessage: true,
                    message: `Report failed, detail:${res.ErrorMessage ? res.ErrorMessage : 'Unknown error, please try again later!'}`,
                    onDismiss: dismissAlert
                })

                setTimeout(() => {
                    dismissAlert();
                }, 2000);
            }
        })

    }, [])

    // /**
    //  * handle review content change
    //  */
    // useEffect(() => {
    //     if (props.reviewContentMarker) {
            
    //         // setUser(props.reviewContentMarker?.TicketInfo?.TicketAssignTo);

    //         // No permission to access the page
    //         if (!isRemediationUser()) {
    //             healingCompleteParams.reviewType = 'NoPermission'
    //             healingCompleteParams.completeTitle = "Thank you!"
    //             history(`/apps/close`, { state: healingCompleteParams })
    //         }

    //     }
    // }, [props.reviewContentMarker])

    // /**
    //  * check if the user is in the remediation user list
    //  * @returns 
    //  */
    // function isRemediationUser() {
    //     let userExsit = RemediationUsers.find((userItem) => userItem.userName === userAccount.username)
    //     if (userAccount.username !== props.reviewContentMarker?.TicketInfo?.RequiredAlias &&
    //         userAccount.username !== props.reviewContentMarker?.TicketInfo?.OptionalAlias &&
    //         userAccount.username !== props.reviewContentMarker?.TicketInfo?.ManagerAlias &&
    //         !userExsit) {
    //         return false;
    //     }

    //     return true;
    // }

    function onDispute() {
        var data = {
            assignTo: "",
            ticketGuid: ticketID,
            curationId: curationID,
            justification: "1",
            dataMart: datamart,
            feedback: ""
        };
        
        if (selectedRadioButton == "ticket") {
            if (user != null && user != "") {
                data.assignTo = user;
            } else {
                setMessageState({
                    messageType: 'error',
                    showMessage: true,
                    message: `Ticket Owner is required option!`,
                    onDismiss: dismissAlert
                })

                setTimeout(() => {
                    dismissAlert();
                }, 1500);
                return;
            }
        } else {
            if (selectedItem != undefined) {
                data.justification = selectedItem.key.toString();
            } else {
                setMessageState({
                    messageType: 'error',
                    showMessage: true,
                    message: `Justification is required option!`,
                    onDismiss: dismissAlert
                })

                setTimeout(() => {
                    dismissAlert();
                }, 1500);
                return;
            }

            if (multilineObservable != null && multilineObservable != null) {
                data.feedback = multilineObservable;
            }
        }

        setIsLoading(true);
        getCorrectOwner(data).then(res => {
            setIsLoading(false);

            if (res.Success) {
                if (selectedRadioButton == "ticket") {
                    // props.getContentMarkerReview(requesturl, ticketID, curationID);
                    props.onLoadTicketInfo(res.Result);
                }
                InitFrom();
                props.onDismiss();

                setMessageState({
                    messageType: 'success',
                    showMessage: true,
                    message: 'Successfully reported!'
                })

                setTimeout(() => {
                    dismissAlert();
                }, 1500);
            }else{
                setMessageState({
                    messageType: 'error',
                    showMessage: true,
                    message: `Report failed, detail:${res.ErrorMessage ? res.ErrorMessage : 'Unknown error, please try again later!'}`,
                    onDismiss: dismissAlert
                })

                setTimeout(() => {
                    dismissAlert();
                }, 2000);
            }

        })

    }

    function InitFrom() {
        // multilineObservable.value = "";
        setMultilineObservable("")
        identityPickerChange(undefined);
    }

    const handleChange = (ev: React.FormEvent<HTMLElement>, option: IChoiceGroupOption) => {
        setSelectedRadioButton(option.key)
        // // 重置错误提示
        // setTicketOwnerError(false);
        // setJustificationError(false);
    };

    return (
        <Dialog
            // titleProps={{ text: "" }}
            // footerButtonProps={[
            //     {
            //         text: "Dispute",
            //         primary: true,
            //         disabled: isLoading,
            //         onClick: onDispute
            //     },
            //     {
            //         text: "Close",
            //         onClick: ()=>{
            //             InitFrom();
            //             props.onDismiss();
            //         }
            //     }
            // ]}
            // onDismiss={props.onDismiss}
            // calloutContentClassName='ticket-content-dialog'

            hidden={false}
            onDismiss={() => {
                InitFrom();
                props.onDismiss();
            }}
            dialogContentProps={{
                type: DialogType.normal,
                title: '',
                showCloseButton: false,
            }}
            modalProps={{
                isBlocking: false,
                className: 'custom-dialog',
            }}
        >

            <div style={{ width: "100%" }}>

                <div style={{ width: '50%', position: 'relative', marginLeft: "25%" }}>
                    <CustomMessageAlert
                        type={messageState.messageType}
                        message={messageState.message}
                        showAlert={messageState.showMessage}
                        onDismiss={messageState.onDismiss}
                    />
                </div>

                {/* <div className='cardTop'>
                    <Card className="cardTopBorder flex-grow">
                        <div style={{ width: "100%" }}>
                            Task ID: <a href={props.reviewContentMarker?.TicketInfo?.TicketUrl}>
                                {props.reviewContentMarker?.TicketInfo?.TicketID}
                            </a> [Assigned to: <a className='cardFontColor'>{props.RequiredReviewers}</a>]
                            <div style={{ float: "right" }}>
                                Dispute request by: <a className='cardFontColor'>{props.Manager}</a>
                            </div>
                        </div>
                    </Card>
                </div> */}

                <div className='cardTop'>
                    <Stack tokens={{ childrenGap: 8 }} className="customCard" style={{ width: "100%" }}>
                        <div style={{ width: "100%" }}>
                            Task ID: <a href={props.reviewContentMarker?.TicketInfo?.TicketUrl}>
                                {props.reviewContentMarker?.TicketInfo?.TicketID}
                            </a> [Assigned to: <a className='cardFontColor'>{props.RequiredReviewers}</a>]
                            <div style={{ float: "right" }}>
                                Dispute request by: <a className='cardFontColor'>{props.Manager}</a>
                            </div>
                        </div>
                    </Stack>
                </div>

                {/* <div className='cardTop'>
                    <Card className="cardBorder flex-grow">
                        <div className="flex-row approveOpption" style={{ flexWrap: "wrap" }}>
                            <span>
                                <h3>
                                    Task Assignment Logic
                                </h3>
                            </span>
                            <span>
                                <div style={{ margin: "25px 0px 15px 0px" }}>
                                    The WorkItem <a href={props.reviewContentMarker?.TicketInfo?.TicketUrl}>{props.reviewContentMarker?.TicketInfo?.TicketID}</a> was associated with the article <a href={requesturl}>{props.reviewContentMarker?.ArticleInfo?.Title}</a>. This was determined as the task is assigned to "{props.RequiredReviewers}" who is either Article Publisher, Writer, Assigned To, Article Creator or Portfolio Owner for this <a href={requesturl}>article</a>. 
                                </div>
                            </span>
                        </div>
                    </Card>
                </div> */}

                <div className='cardTop'>
                    <Stack tokens={{ childrenGap: 8 }} className="customCard" style={{ width: "100%" }}>
                        <div className="flex-row approveOpption" style={{ flexWrap: "wrap" }}>
                            <span>
                                <h3>
                                    Task Assignment Logic
                                </h3>
                            </span>
                            <span>
                                <div style={{ margin: "25px 0px 15px 0px" }}>
                                    The WorkItem <a href={props.reviewContentMarker?.TicketInfo?.TicketUrl}>{props.reviewContentMarker?.TicketInfo?.TicketID}</a> was associated with the article <a href={requesturl}>{props.reviewContentMarker?.ArticleInfo?.Title}</a>. This was determined as the task is assigned to "{props.RequiredReviewers}" who is either Article Publisher, Writer, Assigned To, Article Creator or Portfolio Owner for this <a href={requesturl}>article</a>.
                                </div>
                            </span>
                        </div>
                    </Stack>
                </div>


                {/* <RadioButtonGroup
                    onSelect={selectedId => (setSelectedRadioButton(selectedId))}
                    selectedButtonId={selectedRadioButton} text={""}
                >

                    <div>
                        <Stack tokens={{ childrenGap: 8 }} className="customCard" style={{ width: "100%" }}>
                            <div className="flex-row approveOpption" style={{ flexWrap: "wrap", marginBottom: "10px" }}>
                                <span>
                                    <h3>
                                        Task Action or Dispute
                                    </h3>
                                </span>
                                <span>
                                    <RadioButton className='cardFontWeight' id="ticket" text="Incorrectly assigned to me but I know the correct owner" key="option1" />
                                    <div className='cardTop'>
                                        Please go to the <a href={props.reviewContentMarker?.TicketInfo?.TicketUrl}>task(s)</a> and change the "Assigned To" to the correct owner.
                                    </div>
                                </span>
                                <span>
                                    <div className='cardFontWeight' style={{ marginTop: "20px" }}>
                                        Please change the values of the following article metadata to the correct content owner(s) accordingly.
                                    </div>

                                    <div>
                                        <div className='cardInputTop' style={{ lineHeight: "35px", display: "flex", alignItems: "center", gap: "8px" }}>
                                            <span style={{ minWidth: "100px" }}>Ticket Owner</span>
                                            <div>
                                                {
                                                    userHide ?
                                                        <TextField className='identity-picker-style' placeholder="Loading..." disabled={true} />
                                                        :
                                                        <SingleIdentityPickerExtension
                                                            className={`identity-picker-style`}
                                                            DefaultUserMail={user}
                                                            DefaultUserNull={true}
                                                            onIdentityPickerChange={identityPickerChange} />
                                                }

                                            </div>
                                        </div>
                                        {
                                            ((user == null || user == "") && selectedRadioButton == "ticket") &&
                                            <div style={{ marginLeft: "108px", marginTop: "4px", color: "red", fontSize: "12px" }}>
                                                Ticket Owner is required option!
                                            </div>
                                        }
                                    </div>
                                </span>
                            </div>
                        </Stack>
                    </div>

                    <div>
                        <Stack tokens={{ childrenGap: 8 }} className="customCard" style={{ width: "100%", marginTop: "0px" }}>
                            <div style={{ marginTop: "20px", width: "100%" }}>
                                <span>
                                    <RadioButton className='cardFontWeight' id="justification" key="option1"
                                        text="It's been 24hrs since the task was closed/resolved/triaged but it is still flagged in Sonic and Chiron" />
                                </span>
                                <span>
                                    <div className='cardInputTop'>
                                        <span><span style={{ color: "red" }}>*</span> Justification :</span>
                                        <div style={{ float: "right", width: "80%" }}>
                                            <Dropdown
                                                placeholder="Select an option"
                                                aria-label="Dropdown menu for selecting an option"
                                                options={options}
                                                errorMessage={showError ? 'This dropdown has an error' : undefined}
                                                styles={dropdownStyles}
                                                selectedKey={selectedItem ? selectedItem.key : undefined}
                                                onChange={onChange}
                                                aria-invalid={showError ? 'true' : 'false'}
                                            />
                                        </div>
                                    </div>
                                    <div className='cardInputTop'>
                                        <span> Feedback :</span>
                                        <div style={{ float: "right", width: "80%" }}>
                                            <TextField label="" multiline rows={3} className='DropdownWidth' value={multilineObservable}
                                                aria-label="Enter your comment" placeholder="Type your comment here..." aria-labelledby="Enter your comment"
                                                onChange={(e, newValue) => (multilineObservable.value = newValue)} />
                                        </div>
                                    </div>
                                    <div>
                                        <div className='cardTop' style={{ float: "right", width: "80%" }}>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </Stack>
                    </div>

                </RadioButtonGroup> */}



                <Stack tokens={{ childrenGap: 20 }} style={{ marginTop: "15px" }}>
                    <Stack
                        tokens={{ childrenGap: 16 }}
                        styles={{
                            root: {
                                padding: 16,
                                border: '1px solid #ddd',
                                borderRadius: 6,
                            },
                        }} style={{ paddingBottom: "25px" }}
                    >
                        <h3 style={{ margin: "10px 0px 0px 0px" }}>
                            Task Action or Dispute
                        </h3>

                        <ChoiceGroup
                            selectedKey={selectedRadioButton}
                            options={[{
                                key: 'ticket',
                                text: 'Incorrectly assigned to me but I know the correct owner',
                                onRenderLabel: (props) => (
                                    <span style={{ fontWeight: 700, fontSize: "16px", marginLeft: "30px" }}>{props.text}</span>
                                ),
                            }]}
                            onChange={handleChange}
                        />

                        <div>
                            Please go to the <a href="#">task(s)</a> and change the "Assigned To" to the correct owner.
                        </div>

                        <div className='cardInputTop' style={{ fontWeight: 600, fontSize: "15px" }}>
                            Please change the values of the following article metadata to the correct content owner(s) accordingly.
                        </div>

                        <div className='cardInputTop' style={{ lineHeight: "35px", display: "flex", alignItems: "center", gap: "8px" }}>
                            <span style={{ minWidth: "100px" }}>Ticket Owner</span>
                            <div>
                                {
                                    userHide ?
                                        <TextField className='identity-picker-style' placeholder="Loading..." disabled={true} />
                                        :
                                        <SingleIdentityPickerExtension
                                            className={`identity-picker-style`}
                                            DefaultUserMail={user}
                                            DefaultUserNull={true}
                                            onIdentityPickerChange={identityPickerChange} />
                                }

                            </div>
                        </div>
                        {
                            ((user == null || user == "") && selectedRadioButton == "ticket") &&
                            <div style={{ marginLeft: "108px", marginTop: "4px", color: "red", fontSize: "12px" }}>
                                Ticket Owner is required option!
                            </div>
                        }
                    </Stack>

                    <Stack
                        tokens={{ childrenGap: 16 }}
                        styles={{
                            root: {
                                padding: 16,
                                border: '1px solid #ddd',
                                borderRadius: 6,
                            },
                        }} style={{ paddingBottom: "25px" }}
                    >
                        <ChoiceGroup
                            selectedKey={selectedRadioButton}
                            options={[{
                                key: 'justification',
                                text: "It's been 24hrs since the task was closed/resolved/triaged but it is still flagged in Sonic and Chiron",
                                onRenderLabel: (props) => (
                                    <span style={{ fontWeight: 700, fontSize: "16px", marginLeft: "30px" }}>{props.text}</span>
                                ),
                            }]}
                            onChange={handleChange}
                        />

                        <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="center">
                            <span style={{ minWidth: 100 }}><span style={{ color: 'red' }}>*</span> Justification :</span>
                            <div style={{ float: "right", width: "80%" }}>
                                <Dropdown
                                    placeholder="Select an option"
                                    aria-label="Dropdown menu for selecting an option"
                                    options={options}
                                    errorMessage={showError ? 'This dropdown has an error' : undefined}
                                    styles={dropdownStyles}
                                    selectedKey={selectedItem ? selectedItem.key : undefined}
                                    onChange={onChange}
                                    aria-invalid={showError ? 'true' : 'false'}
                                />
                            </div>
                        </Stack>

                        <Stack horizontal tokens={{ childrenGap: 8 }} verticalAlign="center">
                            <span style={{ minWidth: 100 }}>Feedback :</span>
                            <div style={{ float: "right", width: "80%" }}>
                                <TextField label="" multiline rows={3} className='DropdownWidth' value={multilineObservable}
                                    aria-label="Enter your comment" placeholder="Type your comment here..." aria-labelledby="Enter your comment"
                                    onChange={(e, newValue) => (setMultilineObservable(newValue))} />
                            </div>
                        </Stack>
                    </Stack>
                </Stack>



                <div style={{ margin: "10px 0px" }}>Please contact <a href="mailto:ceskmchironquestions@microsoft.com" className='cardFontColor'>CE&S KM Chiron Questions</a> if you still have questions or need help with the action items.</div>

                {/* {
                    isLoading && <Spinner className='autohealing-loading' label='Loading...' size={SpinnerSize.large} />
                } */}

            </div>


            <DialogFooter>
                <PrimaryButton
                    text="Dispute"
                    onClick={onDispute}
                    disabled={isLoading}
                />
                <DefaultButton
                    text="Close"
                    onClick={() => {
                        InitFrom();
                        props.onDismiss();
                    }}
                />
            </DialogFooter>

        </Dialog>

    )
}

export default connect<StoreProps, DispatchProps>(
    mapStateToProps,
    bindActionCreators.bind({}, actionCreators)
)(TicketAssignedTo);
